import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/switcher.css';


function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
  const [isOpen, setIsOpen] = useState(false); // Track dropdown state

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    i18n.changeLanguage(lang);
    setIsOpen(false); // Close the dropdown after selection
    console.log("Language selected:", lang);
  };

  const flags = {
    fr: (
      <div className="flag-container">
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="#FFFFFF" />
          <rect x="0" y="0" width="10" height="30" fill="#002395" />
          <rect x="10" y="0" width="10" height="30" fill="#FFFFFF" />
          <rect x="20" y="0" width="10" height="30" fill="#ED2939" />
        </svg>
      </div>
    ),
    en: (
      <div className="flag-container">
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="#012169" />
          <path d="M0,15 L30,15 M15,0 L15,30" stroke="#FFFFFF" strokeWidth="4" />
          <path d="M0,15 L30,15 M15,0 L15,30" stroke="#C8102E" strokeWidth="2" />
          <path d="M5,5 L25,25 M25,5 L5,25" stroke="#FFFFFF" strokeWidth="4" />
          <path d="M5,5 L25,25 M25,5 L5,25" stroke="#C8102E" strokeWidth="2" />
        </svg>
      </div>
    ),
    es: (
      <div className="flag-container">
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="#AA151B" />
          <rect x="0" y="10" width="30" height="10" fill="#F1BF00" />
        </svg>
      </div>
    ),
    ar: (
      <div className="flag-container">
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="15" fill="#007A3D" />
          <rect x="0" y="12" width="30" height="6" fill="#FFFFFF" />
          <rect x="0" y="18" width="30" height="6" fill="#000000" />
          <polygon points="0,8 10,15 0,22" fill="#CE1126" />
        </svg>
      </div>
    ),
  };

  return (
    <div className="language-dropdown">
      {/* Langue sélectionnée */}
      <div className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
        {flags[selectedLanguage]}
        <span className="arroww">▼</span>
      </div>

      {/* Liste déroulante */}
      {isOpen && (
        <div className="dropdown-list">
          {Object.keys(flags).map((lang) => (
            <div
              key={lang}
              className="dropdown-item"
              onClick={() => handleLanguageChange(lang)}
            >
              {flags[lang]}
              <span className="lang-label">{lang.toUpperCase()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
